"use client";

import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { getPackProductsApi } from "../api/products.api";
import { Product, PaginatedProductResponse } from "@/types/product.types";
import { productsQueryKeys } from "./useProducts";

export const usePackProducts = (
  params?: { page?: number; limit?: number },
  options?: Partial<UseQueryOptions<PaginatedProductResponse, AxiosError>>
) => {
  return useQuery({
    queryKey: [...productsQueryKeys.all, "pack-products", params],
    queryFn: async () => {
      return getPackProductsApi(params);
    },
    staleTime: 1000 * 60 * 5,
    ...options,
  });
};
